import { AbgSxProps } from '@abg/typings';

export const userCardsWrapper: AbgSxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const userCardsSelectStyles: AbgSxProps = (theme) => ({
  color: 'text.primary',
  height: '40px',
  padding: '8px 16px',

  border: `1px solid ${theme.palette.stroke.lowContrast} !important`,
  width: { xs: '100%', sm: '208px' },
  '& .MuiButton-endIcon .MuiSvgIcon-root': {
    fontSize: '8px',
  },
  '& .MuiButton-startIcon .MuiSvgIcon-root': {
    fontSize: '16px',
  },
});

export const userCardsSelectTypographyStyles: AbgSxProps = {
  flex: '1 0 0',
  textAlign: 'left',
};

export const userCardsMenuListStyles: AbgSxProps = {
  padding: '8px 4px 8px 8px !important',
  width: '173px',
};

export const userCardsMenuPaperStyles = {
  marginLeft: '8px',
  marginTop: 0,
  width: '173px',
};

export const userCardsMenuItemStyles: AbgSxProps = {
  p: 1,
  gap: '12px',
  fontSize: '14px',
};

export const userCardsDividerStyles: AbgSxProps = { my: 3 };

export const userCardsSelectLabelTypographyStyles: AbgSxProps = {
  fontWeight: '500',
};
